//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Facet.js";
import "../no/DisplayableObject.js";
import "../no/ugmath.js";
let d=[[[0,"FaceType",0,0],[0,"IsOccurrence",0,0],[0,"JournalIdentifier",0,0],[0,"Name",0,0],[0,"OwningComponent",0,"Assemblies.Component",0],[0,"OwningPart",0,"BasePart",0],[0,"Prototype",0,"INXObject",0]],[[[],"GetNumberOfEdges",{R_:{number_of_edges:''}},0,0],[["number_of_edges"],"GetEdges",{R_:{faceted_edges:"Facet.FacetedEdge[]"}},0,0],[[],"GetBody",{R_:{faceted_body:"Facet.FacetedBody"}},0,0],[["position","dir","radius","radius_or_angle","sense"],"GetSurfaceData",{},0,0],[["journal_identifier"],"FindObject",{R_:{found:"INXObject"}},1,0],[[],"Print",{},0,0],[["name"],"SetName",{},1,0]],[]];
SPLM.Facet.FacetedFace = class extends SPLM.DisplayableObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Facet.FacetedFace";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Facet.FacetedFace.FacetedfaceType = Object.freeze({
    "Undefined" : "Undefined", "Planar" : "Planar", "Cylindrical" : "Cylindrical", "Conical" : "Conical", "Spherical" : "Spherical", "Toroidal" : "Toroidal", "Parametric" : "Parametric"});

export default SPLM;